import { Button } from 'antd';
import React, { useContext } from 'react';

import client from '@/lib/feathers';

import { GroupBuyingOrdersContext } from '../OrderManagement';
import type { TableValuesFromOrder } from '../types';
import { confirmCancel } from './helper';

interface CancelGroupOrderProps {
  order: TableValuesFromOrder;
}

const CancelGroupOrder = ({ order }: CancelGroupOrderProps) => {
  const { updateOrders } = useContext(GroupBuyingOrdersContext);

  const groupBuyingOrdersService = client.service('groupBuyingOrders');

  return (
    <Button
      type="primary"
      danger
      onClick={() =>
        confirmCancel({ groupBuyingOrdersService, order, updateOrders })
      }
      disabled={order.paymentStatus === '已取消'}
    >
      取消
    </Button>
  );
};

export default CancelGroupOrder;
